module.exports = "./img/a011fd4200387131b97b7f25eb01d674.png";